import ActivityFrame from "@/components/activity-frame/activity-frame";
import { useDialog } from "@/components/dialog/DialogContext";
import { KsKey } from "@/models/KsKey";
import { ListQuery } from "@/models/ListQuery";
import { getKsKeys, saveKsKey } from "@/services/ksKeyService";
import { getErrorMessage } from "@/services/utilities/ServiceError";
import { Form, Formik } from "formik";
import { FC, useState } from "react";
import Modal from 'react-modal';
import { toast } from "react-toastify";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import closeIcon from '../../../../images/close.svg';
import GenerateImportKeyFormContent from "./GenerateImportKeyFormContent";

interface GenerateImportKeyModalProps {
    isOpen: boolean;
    onClose: () => void;
    dataRefresh: (dataMethod?: (query?: any) => Promise<any>) => void;
    action: "IMPORT" | "GENERATE";
}

const GenerateImportKeyModal: FC<GenerateImportKeyModalProps> = ({ isOpen, onClose, dataRefresh, action }) => {
    const { translate } = useLocale();
    const [busy, setBusy] = useState<boolean>(false);
    const dialog = useDialog();
    const initialValues = {
        ksKeyType: "",
        ksKeyTypeId: "1",
        name: ""
    }

    const onSubmit = (values) => {
        setBusy(true);
        const newRecord: KsKey = {
            id: 0,
            ksKeyTypeId: values.ksKeyTypeId,
            name: values.name,
        };

        saveKsKey(newRecord, values.key).then(() => {
            toast.success(translate.byKey(TranslationKeys.success));
            dataRefresh((query?: ListQuery) => getKsKeys(query));
        }).catch((error) => {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        }).finally(() => {
            setBusy(false);
            onClose();
        });        
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content" >
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-1 font-bold font text-white">{translate.byKey(action === "GENERATE" ? TranslationKeys.generateKey : TranslationKeys.importKey)}</p>
            </div>
            <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
        </div>
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSubmit}>
            <Form name="keysForms">
                <div className="py-3 px-3 justify-center content-center" style={{ width: '350px', minHeight: "150px" }} >
                    <ActivityFrame className="flex flex-col w-full h-full" busy={busy}>
                        <GenerateImportKeyFormContent action={action}/>
                    </ActivityFrame>
                </div>
            </Form>
        </Formik>
    </Modal >
}

export default GenerateImportKeyModal;
